<template>
  <vuetify-dialog :ref="reference" :title="title" :button="button" :show="show" :closeable="closeable" @submit="submit">
    <v-form class="pt-3">
      <v-text-field
        v-model="companyName"
        label="Organization"
        placeholder="Company name"
        append-icon="domain"
      />
      <v-text-field
        required
        name="name"
        label="Name"
        placeholder="Your name"
        data-vv-as="Name"
        v-model="userName"
        v-validate="'required'"
        :error-messages="getError('name')"
        @change="validateOnInput"
        append-icon="person"
      />
      <v-text-field
        required
        name="email"
        label="Email"
        placeholder="Email address"
        data-vv-as="Email"
        v-model="email"
        v-validate="'required|email'"
        :error-messages="getError('email')"
        @change="validateOnInput"
        type="email"
        append-icon="email"
      />
      <v-text-field
        v-model="phone"
        mask="phone"
        label="Phone"
        placeholder="Phone number"
        type="phone"
        append-icon="phone"
      />
      <v-text-field
        required
        ref="passwordRef"
        name="password"
        type="password"
        label="Password (minimum 6 characters)"
        placeholder="Password"
        data-vv-as="password"
        v-model="password"
        v-validate="'required|min:6'"
        :error-messages="getError('password')"
        @change="validateOnInput"
        append-icon="visibility_off"
      />
      <v-text-field
        required
        type="password"
        ref="confirmedPassword"
        label="Confirm Password"
        placeholder="Password"
        name="password_confirmation"
        data-vv-as="password"
        v-model="confirmedPassword"
        v-validate="'required|confirmed:passwordRef'"
        :error-messages="getError('password_confirmation')"
        @change="validateOnInput"
        append-icon="visibility_off"
      />
    </v-form>
    <div class="pa-2 mb-3 text-xs-center">
      <v-btn class="v-btn v-btn--large theme--dark success"
         target="_blank" @click="submit">
        {{button}}
      </v-btn>
    </div>
  </vuetify-dialog>
</template>
<script>
import VuetifyDialog from '@/components/VuetifyDialog';

export default {
  components: {
    VuetifyDialog,
  },
  props: {
    title: { type: String, default: "" },
    button: { type: String, default: "Next" },
    closeable: { type: Boolean, default: false },
    reference: { type: String, default: "modal" },
    show: { type: Boolean, default: false },
  },
  data() {
    return {
      companyName: '',
      userName: '',
      email: '',
      phone: '',
      password: '',
      confirmedPassword: '',
      isValid: true,
    };
  },
  methods: {
    getError(name) {
      return this.isValid ? '' : this.errors.first(name);
    },
    validateOnInput() {
      this.isValid = true;
    },
    async submit() {
      this.isValid = await this.$validator.validate();
      if (!this.isValid) {
        return;
      }
      const { companyName, userName, email, phone, password } = this;
      this.$emit('submit', {
        companyName: companyName || userName,
        userName,
        email,
        phone,
        password
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Signup/Account.vue